import React from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../redux/hooks";
import { IRootState } from "../../../types/redux/IRootStore";
import { ReactSelectStyle } from "../../common/rectSelectStyle";
import Spinner from "../../common/Spinner";
import { useTranslation } from "react-i18next";
import ReactSelectWrapper, { IReactSelectOption } from "../../common/ReactSeletWrapper";
import {
    onSetWorkorderDataDirty,
    onSetWorkorderMainData,
    workorderManagementData
} from "../../../redux/slices/workorderManagement.feature";
import { saveWorkorderManagementData } from "../../../aplApi/workorderManagementHelper";
import { WorkorderManagementData } from "../../../types/workorderManagementData";
import { parseChangeEvent } from "../../../aplUtils/formHelper";
import AplSettingsSelector from "../../../redux/helpers/AplSettingsSelector";
import FormInputText from "../../common/FormInputText";
import FormInputNumber from "../../common/FormInputNumber";
import { convertToDateTime } from "../../../aplUtils/dateHelper";
import { WorkorderItem } from "../../../types/workorderItem";
import { tryCatchBootbox } from "../../../aplApi/apiTryCatch";
import DateSelector3 from "../../common/DateSelector3";

export default function WorkorderManagementMainPane() {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const aplSettings = AplSettingsSelector();
    const onSubmit = async (e: any) => {
        e.preventDefault();
        let data = {
            ...workorderManagementRedux.orderData
        } as WorkorderManagementData;
        await tryCatchBootbox(async () => {
            await saveWorkorderManagementData(data);
        });
        if(workorderManagementRedux.orderData)
            dispatch(workorderManagementData(workorderManagementRedux.orderData?.workorderId) as any);
        else
            console.log(`${new Date().toLocaleString()} - WorkorderManagementMainPane.tsx - onSubmit - workorderManagementRedux.orderData is null`);
    };

    const onChange = (e: any) => {
        let data: WorkorderManagementData = {
            ...workorderManagementRedux.orderData,
            ...parseChangeEvent(e)
        } as WorkorderManagementData;
        dispatch(onSetWorkorderMainData(data));
        dispatch(onSetWorkorderDataDirty(true));
    };

    const handleChangeAlternatingWorkorderId = (e: { value: any; label: any }) => {
        if (e == null) {
            let data = {
                ...workorderManagementRedux.orderData,
                alternatingWorkorderId: null
            } as WorkorderManagementData;
            dispatch(onSetWorkorderMainData(data));
        } else {
            let data = {
                ...workorderManagementRedux.orderData,
                alternatingWorkorderId: e.value
            } as WorkorderManagementData;
            dispatch(onSetWorkorderMainData(data));
        }
        dispatch(onSetWorkorderDataDirty(true));
    };


    const workorderManagementRedux = useSelector((state: IRootState) => state.workorderManagement);

    const alternatingWorkordersData: IReactSelectOption[] = workorderManagementRedux.alternatingWokrordersData.map((x: WorkorderItem) => ({
        value: x.workorderId,
        label: `${x.workorder} ${x.description}`
    }));

    if (workorderManagementRedux.orderDataLoading || !workorderManagementRedux.orderData)
        return (
            <React.Fragment>
                <Spinner visible={true} marginsClass={"mt-4"} />
            </React.Fragment>
        );
    return (
        <React.Fragment>
            <div className="container mw-100">
                <form onSubmit={onSubmit} onChange={onChange}>
                    <h5 className="mb-0">{t("main.status")}</h5>
                    <div className="row" id="infoRow02">
                        <div className="col-4">
                            <label htmlFor="effectiveStartDate" className="margin-bottom-02em">
                                {t("main.startDate")}
                            </label>
                            <br />

                            <DateSelector3
                                name="workorder-management-main-start-date"
                                onSetSelectedDate={e => {
                                    let data = {
                                        ...workorderManagementRedux.orderData,
                                        effectiveStartDate: convertToDateTime(e)
                                    };
                                    console.log("here", e, data);

                                    dispatch(onSetWorkorderMainData(data));
                                    dispatch(onSetWorkorderDataDirty(true));
                                }}
                                selectedDate={new Date(workorderManagementRedux.orderData.effectiveStartDate)}
                                culture={aplSettings.culture}
                            />
                        </div>

                        <div className="col-4">
                            <label className="margin-bottom-02em" htmlFor="textbox-qtyScheduled">
                                {t("main.qtyReq")}
                            </label>
                            <FormInputNumber
                                name={"qtyScheduled"}
                                value={workorderManagementRedux.orderData.qtyScheduled}
                                readOnly={true}
                            />
                        </div>

                        <div className="col-4">
                            <label className="margin-bottom-02em" htmlFor="txtAlternatingWorkorder">
                                Alternating Workorder
                            </label>
                            <ReactSelectWrapper
                                data={alternatingWorkordersData}
                                isClearable={true}
                                styles={ReactSelectStyle}
                                isDisabled={![1, 2, 3, 4].includes(aplSettings.siteId)}
                                onChange={handleChangeAlternatingWorkorderId as any}
                                value={alternatingWorkordersData.find(
                                    (x: any) =>
                                        x.value.toLowerCase() ===
                                        workorderManagementRedux.orderData?.alternatingWorkorderId?.toString().toLowerCase()
                                )}
                            />
                        </div>
                    </div>

                    <h5 className="mb-0">{t("main.quantity")}</h5>
                    <div className="row" id="infoRow03a">
                        <div className="col-2">
                            <label className="margin-bottom-02em" htmlFor="textbox-materialStdQty">
                                {t("main.standard")} (full)
                            </label>
                            <FormInputNumber
                                name={"materialStdQty"}
                                value={workorderManagementRedux.orderData.materialStdQty ?? 0}
                                readOnly={true}
                            />
                        </div>

                        <div className="col-2">
                            <label className="margin-bottom-02em" htmlFor="textbox-intSmallQty">
                                {t("main.standard")} (small)
                            </label>
                            <FormInputNumber name={"intSmallQty"} value={workorderManagementRedux.orderData.intSmallQty ?? 0} />
                        </div>

                        <div className="col-2">
                            <label className="margin-bottom-02em" htmlFor="textbox-userStdQty">
                                {t("main.operator")}
                            </label>
                            <FormInputNumber name={"userStdQty"} value={workorderManagementRedux.orderData.userStdQty ?? 0} />
                        </div>

                        <div className="col-2">
                            <label className="margin-bottom-02em" htmlFor="textbox-stdNbLayer">
                                {t("main.layers")}
                            </label>
                            <FormInputNumber name={"stdNbLayer"} value={workorderManagementRedux.orderData.stdNbLayer ?? 0} />
                        </div>

                        <div className="col-2">
                            <label className="margin-bottom-02em" htmlFor="textbox-stdQtyPerLayer">
                                {t("main.quantity")} / {t("main.layers")}
                            </label>
                            <FormInputNumber value={workorderManagementRedux.orderData.stdQtyPerLayer ?? 0} name={"stdQtyPerLayer"} />
                        </div>

                        <div className="col-2">
                            <label className="margin-bottom-02em" htmlFor="textbox-palletWeight">
                                {t("main.palletWeight")}
                            </label>
                            <FormInputNumber name={"palletWeight"} value={workorderManagementRedux.orderData.palletWeight ?? 0} />
                        </div>
                    </div>

                    <div className="row" id="infoRow03c">
                        <div className="col-2">
                            <label className="margin-bottom-02em" htmlFor="textbox-interlayer">
                                {t("main.interlayer")}
                            </label>
                            <FormInputText name={"interlayer"} value={workorderManagementRedux.orderData.interlayer ?? ""} />
                        </div>
                        <div className="col-2">
                            <label className="margin-bottom-02em" htmlFor="textbox-pallet">
                                {t("main.pallet")}
                            </label>
                            <FormInputText name={"pallet"} value={workorderManagementRedux.orderData.pallet ?? ""} />
                        </div>
                        <div className="col-2">
                            <label className="margin-bottom-02em" htmlFor="textbox-foil">
                                {t("main.foil")}
                            </label>
                            <FormInputText name={"foil"} value={workorderManagementRedux.orderData.foil ?? ""} />
                        </div>
                        <div className="col-2">
                            <label className="margin-bottom-02em" htmlFor="textbox-carton">
                                {t("main.carton")}
                            </label>
                            <FormInputText name={"carton"} value={workorderManagementRedux.orderData.carton ?? ""} />
                        </div>
                        <div className="col-2">
                            <label className="margin-bottom-02em" htmlFor="textbox-articleWeight">
                                {t("main.articleWeight")}
                            </label>
                            <FormInputNumber name={"articleWeight"} value={workorderManagementRedux.orderData.articleWeight ?? 0} />
                        </div>
                        <div className="col-2"></div>
                        <div className="col-2"></div>
                    </div>

                    

                    <h5 className="mb-0">{t("main.customerDetails")}</h5>
                    <div className="row" id="infoRow01">
                        <div className="col-4">
                            <label className="margin-bottom-02em" htmlFor="textbox-customerCode">
                                {t("main.litCustCode")}
                            </label>
                            <FormInputText name={"customerCode"} value={workorderManagementRedux.orderData.customerCode ?? ""} />
                        </div>

                        <div className="col-4">
                            <label className="margin-bottom-02em" htmlFor="textbox-customerName">
                                {t("main.litNameCust")}
                            </label>
                            <FormInputText name={"customerName"} value={workorderManagementRedux.orderData.customerName ?? ""} />
                        </div>

                        <div className="col-4">
                            <label className="margin-bottom-02em" htmlFor="textbox-custArticleDesc">
                                {t("main.litCustMatDesc")}
                            </label>
                            <FormInputText name={"custArticleDesc"} value={workorderManagementRedux.orderData.custArticleDesc ?? ""} />
                        </div>
                    </div>
                    <div className="row" id="infoRow06">
                        <div className="col-4">
                            <label className="margin-bottom-02em" htmlFor="textbox-crCusMaterialCode">
                                {t("main.litCustMat")}
                            </label>
                            <FormInputText name={"crCusMaterialCode"} value={workorderManagementRedux.orderData.crCusMaterialCode ?? ""} />
                        </div>
                        <div className="col-4">
                            <label className="margin-bottom-02em" htmlFor="textbox-customerGtin">
                                {t("main.customerGTIN")}
                            </label>
                            <FormInputText name={"customerGtin"} value={workorderManagementRedux.orderData.customerGtin ?? ""} />
                        </div>
                        <div className="col-4"></div>
                    </div>
                    <div className="row" id="infoRow07">
                        <div className="col-4">
                            <label className="margin-bottom-02em" htmlFor="textbox-customerCrossRefA">
                                {t("main.custCrossRef")} (A)
                            </label>
                            <FormInputText name={"customerCrossRefA"} value={workorderManagementRedux.orderData.customerCrossRefA ?? ""} />
                        </div>
                        <div className="col-4">
                            <label className="margin-bottom-02em" htmlFor="textbox-customerCrossRefB">
                                {t("main.custCrossRef")} (B)
                            </label>
                            <FormInputText name={"customerCrossRefB"} value={workorderManagementRedux.orderData.customerCrossRefB ?? ""} />
                        </div>
                        <div className="col-4">
                            <label className="margin-bottom-02em" htmlFor="textbox-customerCrossRefC">
                                {t("main.custCrossRef")} (C)
                            </label>
                            <FormInputText name={"customerCrossRefC"} value={workorderManagementRedux.orderData.customerCrossRefC ?? ""} />
                        </div>
                    </div>

                    <div className="row" id="infoRow08">
                        <div className="col-4">
                            <label className="margin-bottom-02em" htmlFor="texbox-specialText1">
                                {t("main.specialText")} (1)
                            </label>
                            <FormInputText name={"specialText1"} value={workorderManagementRedux.orderData.specialText1 ?? ""} />
                        </div>
                        <div className="col-4">
                            <label className="margin-bottom-02em" htmlFor="texbox-specialText2">
                                {t("main.specialText")} (2)
                            </label>
                            <FormInputText name={"specialText2"} value={workorderManagementRedux.orderData.specialText2 ?? ""} />
                        </div>
                        <div className="col-4">
                            <label className="margin-bottom-02em" htmlFor="texbox-specialText3">
                                {t("main.specialText")} (3)
                            </label>
                            <FormInputText name={"specialText3"} value={workorderManagementRedux.orderData.specialText3 ?? ""} />
                        </div>
                    </div>

                    <div className="row" id="infoRow09">
                        <div className="col-4">
                            <label className="margin-bottom-02em" htmlFor="textbox-micron">
                                Micron
                            </label>
                            <FormInputNumber name={"micron"} value={workorderManagementRedux.orderData.micron ?? undefined} />
                        </div>
                        <div className="col-4">
                            <label className="margin-bottom-02em" htmlFor="textbox-shrinkCode">
                                ShrinkCode
                            </label>
                            <FormInputText name={"shrinkCode"} value={workorderManagementRedux.orderData.shrinkCode ?? ""} />
                        </div>
                        <div className="col-4">
                            
                        </div>
                    </div>

                    <div>&nbsp;</div>

                    <div className="form-group row">
                        <div className="col-sm-10">
                            <div className="form-check form-check-inline">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="chkInLine"
                                    value="chkInLine"
                                    defaultChecked={workorderManagementRedux.orderData.inLine ?? false}
                                    name={"inLine"}
                                    onChange={() => {}}
                                />
                                <label className="form-check-label" htmlFor="chkInLine">
                                    {t("main.inLine")}
                                </label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="chkWorkorderIgnoreSap"
                                    value="chkWorkorderIgnoreSap"
                                    defaultChecked={workorderManagementRedux.orderData.hasManualEdit ?? false}
                                    name={"hasManualEdit"}
                                    onChange={() => {}}
                                />
                                <label className="form-check-label" htmlFor="chkWorkorderIgnoreSap">
                                    {t("main.ignoreSapUpdates")}
                                </label>
                            </div>
                        </div>
                        <div className="col-sm-2">
                            <input
                                type="submit"
                                className="btn btn-primary float-right"
                                onClick={onSubmit}
                                value={t("main.save")!}
                                disabled={!workorderManagementRedux.orderDataDirty}
                            />
                        </div>
                    </div>

                    <br />
                </form>
            </div>
        </React.Fragment>
    );
}
